import { BalanceSheetReportType } from "pages/Finance/Report/types"
import { Fragment } from "react"
import { ItemTotal } from "../ItemTotal"
import { CoaHeaderEnum } from "pages/Accounts/Report/BugetManager/enum"
import { CollapsedButton } from "components"
import { CoaEnum } from "pages/Accounts/Report/ProfitAndLoss/enums"
import { ColumnSection } from "../ColumnSection"
import { Link } from "react-router-dom"
import { useStoreFillter } from "pages/Accounts/Report/TransactionDetail/utils"
import moment from "moment"

type ItemProps = {
  list: Array<BalanceSheetReportType>
  item: BalanceSheetReportType
  displayAccountNumber: boolean
  displaySubHeader: boolean
  displayDetail: boolean
  isPNL?: boolean
  collapsed?: Record<string, boolean>
  isCollapsed?: (id: number) => boolean
  toggleCollapse?: (id: number) => void,
  date?: string,
  dateTo?: string
  comparisonDates?: string[]
}

export function Item({ list, item, displayAccountNumber, displaySubHeader, displayDetail, isPNL, collapsed, isCollapsed, toggleCollapse, date, dateTo, comparisonDates }: ItemProps) {
  moment.locale("id");
  const { setFilter } = useStoreFillter()

  const isNormalFontWeight = [3].includes(item.header_level)
  const isNetAssets = item.coa_name === CoaEnum.NET_ASSETS
  const isNetProfit = item.coa_name === CoaEnum.NET_PROFIT
  const isDisplaySubHeader = item.header_level === CoaHeaderEnum.SUB_HEADER && displaySubHeader
  const isDisplayDetail = item.header_level === CoaHeaderEnum.DETAIL && displayDetail
  const isDetail = item.header_level === CoaHeaderEnum.DETAIL
  // const shouldAb = /^05-12/.test(String(item.coacode));
  const total = item?.balance?.reduce((acc, curr) => acc + (curr ?? 0), 0) ?? 0;
  // const summary = shouldAb ? Math.abs(total) : total;
  // const average = shouldAb && item.balance?.length ? Math.abs(total / item.balance.length) : total / (item.balance?.length || 1);
  const average = total / (item.balance?.length || 1);

  const showBalance = isNetAssets || isNetProfit || isDetail
  const onHideBalance = <td>{""}</td>
  const isCompare = comparisonDates && comparisonDates.length > 1

  return (
    <Fragment>
      <tr
        key={item.coa_id}
        style={{ display: isDisplayDetail || isDisplaySubHeader || item.header_level === CoaHeaderEnum.HEADER ? "table-row" : "none" }}
      >
        <td>
          <span
            className={`${isNormalFontWeight ? "font-normal" : "font-bold"} ${isPNL ? "flex items-center" : ""}`}
            style={{ marginLeft: (item.coa_level - 1) * 24 }}
          >

            <CollapsedButton
              key={item?.coa_level}
              onShow={isCollapsed && isCollapsed(item.coa_id)}
              style={{
                opacity: !isNormalFontWeight ? "100%" : "0%",
                cursor: !isNormalFontWeight ? "pointer" : "default"
              }}
              onClick={() => {
                !isNormalFontWeight && toggleCollapse && toggleCollapse(item?.coa_id)

                const store = isPNL ? "coaPNL" : "coaBS"
                localStorage.setItem(store, String(item?.coa_id))
              }}
            />

            {isNormalFontWeight ? (
              <Link
                to="/accounts/report/transaction-detail"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  setFilter((prev) => ({
                    ...prev,
                    coa: [item.coa_id.toString()],
                    start_date: date ?? moment().startOf("year").format("YYYY-MM-DD"),
                    end_date: dateTo ?? moment().format("YYYY-MM-DD"),
                    location_id: "0",
                  }))
                }
                }
              >
                <span className="me-2 text-nowrap cursor-pointer p-2 bg-slate-100 rounded-lg hover:bg-slate-200">
                  {displayAccountNumber ? item.coacode : ""}
                </span>
              </Link>
            ) : (
              <span className="me-2 text-nowrap">
                {displayAccountNumber ? item.coacode : ""}
              </span>
            )}


            <span className={displayAccountNumber && item.coacode ? "border-s-[1px] pe-3" : "border-none"} />
            <span className="text-nowrap">{`${item.coa_name}`}</span>


          </span>
        </td>

        {showBalance
          ? item.balance?.map((balance, index) => {
              // const displayBalance = shouldAbs ? Math.abs(balance ?? 0) : (balance ?? 0);
              const displayBalance = balance ?? 0;
              const comparisonDate = comparisonDates?.[index] ?? null;

              const startDateCompare = moment(comparisonDate, "MMM YYYY").startOf("month").format("YYYY-MM-DD");
              const endDateCompare = moment(comparisonDate, "MMM YYYY").endOf("month").format("YYYY-MM-DD");

              const startDateLink = isCompare ? startDateCompare : date ?? moment().startOf("year").format("YYYY-MM-DD");
              const endDateLink = isCompare ? endDateCompare : dateTo ?? moment().format("YYYY-MM-DD");
              

              return (
                <ColumnSection 
                  isDetail
                  key={balance + index} 
                  account={item.coa_id.toString()}
                  isNormalFontWeight={isNormalFontWeight} balance={displayBalance} isPNL={isPNL} 
                  startDate={startDateLink}
                  endDate={endDateLink}
                  />
                )
            })
          : item?.balance?.map(_ => (onHideBalance)
        )}
        {isPNL && (showBalance) ? <ColumnSection key={total} isPNL={isPNL} isNormalFontWeight={isNormalFontWeight} balance={total} /> : isPNL && onHideBalance}
        {isPNL && (showBalance) ? <ColumnSection key={average} isPNL={isPNL}  isNormalFontWeight={isNormalFontWeight} balance={average} /> : isPNL && onHideBalance}
      </tr>

      {isCollapsed && isCollapsed(item.coa_id) && list
        .filter(sub => sub.parent_id === item.coa_id)
        .map((sub, key) => (
          <Item
            isPNL={isPNL}
            key={sub.coa_id + key}
            list={list}
            item={sub}
            displayAccountNumber={displayAccountNumber}
            displaySubHeader={displaySubHeader}
            displayDetail={displayDetail}
            collapsed={collapsed}
            toggleCollapse={toggleCollapse}
            isCollapsed={isCollapsed}
            date={date}
            dateTo={dateTo}
            comparisonDates={comparisonDates}
          />
        ))
      }

      {(isDisplaySubHeader || isDisplayDetail) && item.header_level !== CoaHeaderEnum.DETAIL ? <ItemTotal isPNL={isPNL} item={item} /> : null}
    </Fragment>
  )
}